import { render, staticRenderFns } from "./EditTree.vue?vue&type=template&id=563a1b99&scoped=true&"
import script from "./EditTree.vue?vue&type=script&lang=js&"
export * from "./EditTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563a1b99",
  null
  
)

export default component.exports